module.exports = __webpack_public_path__ + "media/images/symbols/email-336170f17e5a8d19df51757d6fda900f.svg";